export const SERVICE_CODE = 'CONTRACTOR_CATEGORY' + '_SERVICE';
